import React from "react";

// New format default data
export const defaultRehabData = [
  {
    group: "Employees",
    affected_current: "",
    rehired_current: "",
    affected_previous: "",
    rehired_previous: "",
  },
  {
    group: "Workers",
    affected_current: "",
    rehired_current: "",
    affected_previous: "",
    rehired_previous: "",
  },
];

const RehabilitationEmploymentTable = ({ rehabdata = {}, setRehabData }) => {
  // Normalize to array format if needed
  const normalizedRehabData = Array.isArray(rehabdata)
    ? rehabdata
    : Object.entries(rehabdata).map(([group, values]) => ({
        group,
        affected_current: values?.current?.affected || "",
        rehired_current: values?.current?.rehired || "",
        affected_previous: values?.previous?.affected || "",
        rehired_previous: values?.previous?.rehired || "",
      }));

  const handleChange = (index, field, value) => {
    const updated = [...normalizedRehabData];
    updated[index][field] = value;
    setRehabData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th colSpan={2} style={headerStyle}>
              Total number of affected
            </th>
            <th colSpan={2} style={headerStyle}>
              No. of employees/workers that are rehabilitated and placed in
              suitable employment or whose family members placed in suitable
              employment.
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th style={headerStyle}>Current FY</th>
            <th style={headerStyle}>Previous FY</th>
            <th style={headerStyle}>Current FY</th>
            <th style={headerStyle}>Previous FY</th>
          </tr>
        </thead>
        <tbody>
          {normalizedRehabData.map((row, index) => (
            <tr key={row.group}>
              <td style={categoryStyle}>{row.group}</td>

              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.affected_current}
                  onChange={(e) =>
                    handleChange(index, "affected_current", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.affected_previous}
                  onChange={(e) =>
                    handleChange(index, "affected_previous", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.rehired_current}
                  onChange={(e) =>
                    handleChange(index, "rehired_current", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.rehired_previous}
                  onChange={(e) =>
                    handleChange(index, "rehired_previous", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "20%",
  wordWrap: "break-word",
};

const categoryStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#F0E9EC",
  width: "20%",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "20%",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "15px",
  textAlign: "center",
  backgroundColor: "white",
  outline: "none",
  boxSizing: "border-box",
};

export default RehabilitationEmploymentTable;
